import React from 'react';
import { AlertModal } from 'src/componentsTailwind/index';

const ConfirmArchivePulseModal = ({
  pulseQuestionId,
  isLoading,
  close,
  archiveFn
}) => (
  <AlertModal
    isLoading={isLoading}
    isOpen
    close={close}
    onAction={() => archiveFn(pulseQuestionId)}
    title='Are you sure you want to archive this pulse question?'
  />
);

export default ConfirmArchivePulseModal;
